import { render, staticRenderFns } from "./NewCustomerModal.vue?vue&type=template&id=103fa6d2&scoped=true&"
import script from "./NewCustomerModal.vue?vue&type=script&lang=ts&"
export * from "./NewCustomerModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewCustomerModal.vue?vue&type=style&index=0&id=103fa6d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103fa6d2",
  null
  
)

export default component.exports